"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Fetches an entity from the cache, taking as type parameter the entity
 * has when denormalized, but returning the type it will have as a normalized entity.
 * @param key The cache key
 * @param cache The cache
 */
function getNormalizedEntity(key, cache) {
    return cache[key];
}
exports.getNormalizedEntity = getNormalizedEntity;
/**
 * An optimized function to merge two cache objects (as returned from normalize)
 * @param entities The first cache
 * @param newEntities The second cache
 */
function mergeEntityCache(entities, newEntities) {
    var updatedEntities = Object.keys(newEntities).reduce(function (stateSoFar, current) {
        var newEntity = __assign({}, (entities[current] || {}), newEntities[current]);
        stateSoFar[current] = newEntity;
        return stateSoFar;
    }, {});
    return __assign({}, entities, updatedEntities);
}
exports.mergeEntityCache = mergeEntityCache;
/**
 * Removes the stale flag for entitiy fields that are present in the normalized result
 */
function updateStale(cache, stale) {
    // Make a shallow copy to enable shallow mutation
    var staleCopy = __assign({}, stale);
    // Check all stale entities against the cache
    for (var _i = 0, _a = Object.keys(staleCopy); _i < _a.length; _i++) {
        var staleKey = _a[_i];
        var entity = cache[staleKey];
        if (entity !== undefined) {
            var staleEntity = staleCopy[staleKey];
            var staleEntityFields = Object.keys(staleEntity || {});
            var staleEntityFieldCount = staleEntityFields.length;
            // Check all fields of the stale entity against the corresponding entity in cache
            // If a field exists in cache, then it should not be stale anymore
            var staleEntityCopy = undefined;
            for (var _b = 0, staleEntityFields_1 = staleEntityFields; _b < staleEntityFields_1.length; _b++) {
                var staleEntityField = staleEntityFields_1[_b];
                for (var _c = 0, _d = Object.keys(entity); _c < _d.length; _c++) {
                    var entityField = _d[_c];
                    if (entityField === staleEntityField) {
                        if (!staleEntityCopy) {
                            staleEntityCopy = __assign({}, staleEntity);
                            staleCopy[staleKey] = staleEntityCopy;
                        }
                        delete staleEntityCopy[staleEntityField];
                        staleEntityFieldCount--;
                    }
                }
            }
            // If the entity has no stale fields then remove it from stale
            if (staleEntityFieldCount === 0) {
                delete staleCopy[staleKey];
            }
        }
    }
    return staleCopy;
}
exports.updateStale = updateStale;
//# sourceMappingURL=entity-cache.js.map